import { render, staticRenderFns } from "./Tariff.vue?vue&type=template&id=7a244aea&"
import script from "./Tariff.vue?vue&type=script&lang=ts&"
export * from "./Tariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports